// ----------------------------------------------------------------------

const account = [
  {
    id: 'acc-001',
    displayName: 'Ulugbek Temirov',
    role: 'admin',
    email: 'temirovulugbek2003@gmail.com',
    photoURL: '/assets/images/avatars/avatar.png',
    phoneNumber: '+998 99 123 45 67',
    username: 'ulugbektemirov',
    password: '12345678',
  },
  {
    id: 'acc-002',
    displayName: 'Shahzod Aktamov',
    role: 'vendor',
    email: 'shahzodaktamov@gmail.com',
    photoURL: 'https://xsgames.co/randomusers/assets/avatars/male/63.jpg',
    phoneNumber: '+998 99 234 56 78',
    username: 'shahzodaktamov',
    password: '87654321',
  },
  {
    id: 'acc-003',
    displayName: 'Jamshid Zayniyev',
    role: 'vendorUser',
    email: 'jamshidzayniyev@gmail.com',
    photoURL: 'https://xsgames.co/randomusers/assets/avatars/male/74.jpg',
    phoneNumber: '+998 99 345 67 89',
    username: 'jamshidzayniyev',
    password: '87654321',
  },
];

export default account;
